import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { TRIAL } from 'pricing-pages-lib/constants/CtaTypes';
import { getHubsSignupUrl } from 'pricing-pages-lib/utils/publicPageUrls';
import { getDTTUrl } from 'pricing-pages-lib/utils/urls';
import { productForSkuIdSelector } from 'pricing-pages-ui/selectors/ProductsSelectors';
import { hubsSignupCTASelector } from 'pricing-pages-ui/selectors/TrackingSelectors';
import Raven from 'raven-js';
import { useSelector } from 'react-redux';
import { apiNameToTrialIds } from 'self-service-api/constants/Trials';
import { useGlobalLoading } from '../../../hooks/loadingHooks';
import { getEligiblePublicTreatmentsSelector } from '../../../selectors/ExperimentSelectors';
import { isUngatedForSeatsSelector } from '../../../selectors/GatingSelectors';
import { formatPublicExperimentationForQueryParams } from '../../../utils/experimentationUtils';
import { trackTrialButtonClick } from '../../../v2/utils/tracking/trackingEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const isValidTrialId = trialId => {
  return typeof trialId === 'number' && Object.values(apiNameToTrialIds).includes(trialId);
};
const DTTButton = ({
  skuId,
  trialId,
  upgradeSource,
  sourceId,
  use,
  size,
  onClick
}) => {
  if (trialId && skuId) {
    throw new Error('Should provide either trialId or skuId, but not both');
  } else if (!trialId && !skuId) {
    throw new Error('Must supply either trialId or skuId');
  }
  const isAppReady = useGlobalLoading();
  const {
    apiName
  } = useSelector(state => productForSkuIdSelector(state, {
    skuId
  }));
  const eligibleTreatments = useSelector(getEligiblePublicTreatmentsSelector);
  if (apiName) {
    const trialIdFromApiName = apiNameToTrialIds[apiName];
    if (isValidTrialId(trialIdFromApiName)) {
      trialId = trialIdFromApiName;
    } else {
      const error = `Couldn't find trialId for apiName`;
      const extra = {
        apiName,
        apiNameToTrialIds,
        trialIdFromApiName
      };
      Raven.captureException(new Error(error), {
        extra
      });
      console.error(error, extra);
    }
  }
  const hubsSignupCta = useSelector(state => hubsSignupCTASelector(state, {
    pathname: window.location.pathname,
    skuId,
    ctaType: TRIAL,
    sourceId,
    isAppReady
  })) || '';
  const hubsSignupUrl = getHubsSignupUrl({});
  const isUngatedForSeats = useSelector(isUngatedForSeatsSelector);
  const uuid = window.__utAnonId;
  const experimentParamString = formatPublicExperimentationForQueryParams(eligibleTreatments);
  let HREF;
  if (trialId && upgradeSource) {
    HREF = `${getDTTUrl(trialId, upgradeSource)}&hubs_signup-url=${hubsSignupUrl}&hubs_signup-cta=${hubsSignupCta}&hsSeats=${isUngatedForSeats}&uuid=${uuid}`;
    if (experimentParamString) {
      HREF += `&${experimentParamString}`;
    }
  }
  if (!HREF) {
    return null;
  }
  return /*#__PURE__*/_jsx(Button, {
    "data-selenium-id": `${sourceId}-${apiName}-TRIAL-button`,
    href: HREF,
    use: use,
    onClick: event => {
      trackTrialButtonClick({
        apiName,
        trackingSource: upgradeSource,
        productName: apiName,
        formattedExperimentArray: eligibleTreatments.map(treatment => `${treatment.treatmentKey}|${treatment.group}`)
      });
      onClick === null || onClick === void 0 || onClick(event);
    },
    size: size,
    block: true,
    margin: "0",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `pricingPage.pricingCtas.startTrial`
    })
  });
};
export default DTTButton;